

import React from 'react';

const Security = () => {
  return (
    <div>
      <section className="banner gen-banner security-banner">
        <div className="container">
          <div className="row  ">
            <div className="col-12">
              <div className="gen-banner-text">
                <h1>iCause Security, Always dummy text lorem ipsum</h1>
                <p className="mb-0">The iCause event manager makes planning your event easier – manage registration, communications, merchandise and donations in one simple platform.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="serice-item my-5 security-sec-2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 security-2-card text-center">
              <img src="/images/icon1.PNG" alt="" />
              <h4 className=" font-weight-bold mb-0 mt-3  text-center">Cyber Security</h4>
              <p>Becoming one of our partners is easy simply follow the link to create your iCause account.</p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 security-2-card text-center">
              <img src="/images/icon2.PNG" alt="" />
              <h4 className=" font-weight-bold mb-0 mt-3  text-center">Dynamic Testing</h4>
              <p>Becoming one of our partners is easy simply follow the link to create your iCause account.</p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 security-2-card text-center">
              <img src="/images/icon1.PNG" alt="" />
              <h4 className=" font-weight-bold mb-0 mt-3  text-center">Functionality</h4>
              <p>Becoming one of our partners is easy simply follow the link to create your iCause account.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-4 security-sec-3">
        <div className='container'>
          <div className='row d-flex align-items-center  '>

            <div className='col-lg-6 col-md-7 pl-md-5'>
              <div className="custom-text-box">
                <img src="/images/security-sec-3-icon.png" alt="" className="img-fluid"/>
                <h5 className="text-grn mt-1  border-left-one">Secure Payment Process</h5>
                <h3 className="main-heading mt-md-0">We assure you!</h3>
                <p className="mt-4">Becoming one of our partners is easy – simply follow the link to create your iCause account and you’ll be up and running in no time. You’ll need to enter your organization's details, a nominated bank account for the.</p>
              </div>
            </div>
            <div className='col-lg-6 col-md-5 trending-causes d-flex justify-content-end'>
              <div className="security-sec-3-img">
                <img src="/images/security-sec-3-img.png" className="img-fluid w-100" alt="img" />
              </div>
            </div>

          </div>
        </div>
      </section>
      <section className="pt-4 security-sec-4">
        <div className='container'>
          <div className='row d-flex align-items-center  '>
            <div className='col-lg-6 col-md-5 trending-causes order-md-1 order-sm-2'>
              <div className="security-sec-4-img">
                <img src="/images/security-sec-4-img.png" className="img-fluid w-100" alt="img" />
              </div>
            </div>
            <div className='col-lg-6 col-md-7 pl-md-5 d-flex justify-content-end  order-md-2 order-sm-1'>
            <div className="custom-text-box">
              <img src="/images/security-sec-4-icon.png" alt="" className="img-fluid"/>
              <h5 className="text-grn mt-2 border-left-one">Quick Funds Transfer</h5>
              <h3 className="main-heading    mt-md-0">Transfer your Funds with<br></br> Utility Bills</h3>
              <p className="mt-4">Becoming one of our partners is easy – simply follow the link to create your iCause account and you’ll be up and running in no time. You’ll need to enter your organization's details, a nominated bank account for the.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="security-about mb-5 security-sec-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-11 security-about-bg mx-auto">
              <h3 className="mt-md-0">About Website Security...</h3>
              <p className="">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit obortis nisl ut aliquip ex ea commodo consequat.</p>
              <p className="">Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.</p>
              <p className="">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
              <ul>
                <li><i className="fa fa-check-circle-o fa-2x text-grn mr-2"></i>Contrary to popular belief, Lorem Ipsum is not simply random text.</li>
                <li> <i className="fa fa-check-circle-o fa-2x text-grn mr-2"></i>Comes from a line in section 1.10.32.</li>
                <li> <i className="fa fa-check-circle-o fa-2x text-grn mr-2"></i>Finibus Bonorum et Malorum</li>
              </ul>
              <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit obortis nisl ut aliquip ex ea commodo consequat.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Security;
